<template lang="html">
  <div>
    <v-col cols="12">
      <div class="subtitle-2 font-weight-bold mb-2">
        {{ `${$tc('title.configuracao_acesso', 1)}:` }}
      </div>
      <v-divider class="mb-4"></v-divider>
    </v-col>
    <v-row class="ml-4 mb-6">
      <v-col cols="2" sm="2" md="2">
        <label class="v-label theme--light caption grey--text text--darken-1 d-block mb-1">
          {{ `${$tc('label.status', 1)}*` }}
        </label>
        <v-btn-toggle
          v-model="usuario.indAtivo"
          mandatory
          dense
          class="custom-toggle"
        >
          <v-btn
            :value="true"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor || (!isNovoCadastro && !indAtivoOriginal)"
            :class="usuario.indAtivo ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.ativo') }}
          </v-btn>
          <v-btn
            :value="false"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
            :class="!usuario.indAtivo ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.inativo') }}
          </v-btn>
        </v-btn-toggle>
         <div v-if="!isNovoCadastro" class="grey--text text--darken-1 caption mt-1 lh-tight">
            {{ mensagemVigencia }}
          </div>
      </v-col>

      <v-col cols="2" sm="2" md="2">
        <label class="v-label theme--light caption grey--text text--darken-1 d-block mb-1">
          {{ `${$tc('label.notificacao_email', 1)}*` }}
        </label>
        <v-btn-toggle
          v-model="usuario.indRecebeMail"
          mandatory
          dense
          class="custom-toggle"
        >
          <v-btn
            :value="true"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
            :class="usuario.indRecebeMail ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.inscrito') }}
          </v-btn>
          <v-btn
            :value="false"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
            :class="!usuario.indRecebeMail ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.suspenso') }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="4" sm="4" md="4" slot="antes">
        <v-autocomplete
          id="usuario-perfil"
          class="custom-autocomplete"
          :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          required
          :rules="[rules.required]"
          :no-data-text="$tc('message.nenhum_registro', 1)"
          :label="`${$tc('label.perfil', 1)} *`"
          v-model="usuario.idPerfil"
          :items="perfis"
          item-text="nomPerfil"
          item-value="id"
          clearable>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4" md="4" slot="antes">
        <v-text-field
          :label="$t('label.tipo_fornecedor')"
          v-model="usuario.tipoFornecedor"
          autocomplete="null"
          maxlength="100"
          counter
          :disabled="true">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-autocomplete
          id="usuario-grupo-fornecedor"
          class="custom-autocomplete"
          v-model="filtroGrupoFornecedor"
          :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          :label="`${$tc('label.grupo_fornecedor', 1)}`"
          :items="gruposFornecedores"
          item-text="nome"
          item-value="id"
          clearable
          clear-on-select
          deletable-chips
          @click:append="() => triggerSelecao('usuario-grupo-fornecedor')"
          @click.native="(i) => buscaAutocomplete(i, buscaGruposFornecedores)"
          :search-input.sync="triggerGrupoFornecedor">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="8" md="8">
        <v-btn
          id="btn_incluir_linha"
          :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          @click.native="incluirLinhaGrupoFornecedor(filtroGrupoFornecedor)"
          color="primary">
          {{ $t('label.adicionar') }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <usuario-grupo-fornecedor-list
          ref="usuarioGrupoFornecedorList"
          :lista-grupo-fornecedores="listaGrupoFornecedores"
          :somente-leitura="somenteLeitura"
          :desabilitar-cadastro-fornecedor="desabilitarCadastroFornecedor">
      </usuario-grupo-fornecedor-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { triggerSelecao, buscaAutocomplete } from '@/common/functions/autocomplete-utils';
import UsuarioGrupoFornecedorList from '@/spa/usuario/UsuarioGrupoFornecedorList';

export default {
  name: 'UsuarioFornecedorConfiguracoesAcesso',
  props: {
    somenteLeitura: Boolean,
    default: false,
    usuario: {
      type: Object,
      default: {},
    },
    encontrouOmni: {
      type: Boolean,
      default: false,
    },
    isNovoCadastro: {
      type: Boolean,
      default: false,
    },
    isSomenteLeituraDadosSensiveis: {
      type: Boolean,
      default: false,
    },
    desabilitarCadastroFornecedor: {
      type: Boolean,
      default: false,
    },
    tenantsUsuario: {
      type: Array,
      default: [],
    },
    perfis: {
      type: Array,
      default: () => ([]),
    },
    gruposFornecedores: {
      type: Array,
      default: () => ([]),
    },
    usuarioLogado: {
      type: Object,
      default: () => ({}),
    },
    indAtivoOriginal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UsuarioGrupoFornecedorList,
  },
  computed: {
    mensagemVigencia() {
      const dataInicio = this.usuario.dtaInicioVigencia
        ? this.moment(this.usuario.dtaInicioVigencia).format('DD/MM/YYYY')
        : '--/--/----';

      const dataFim = this.usuario.dtaFimVigencia
        ? this.moment(this.usuario.dtaFimVigencia).format('DD/MM/YYYY')
        : '--/--/----';
      return this.$t('message.vigencia_aprovador_autorizado_inicio_fim', { dataInicio, dataFim });
    },
  },
  watch: {
    triggerGrupoFornecedor(val) {
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscaGruposFornecedores(val);
      }, 500);
    },
  },
  data() {
    return {
      showHint: false,
      timeoutTrigger: null,
      triggerGrupoFornecedor: null,
      filtroGrupoFornecedor: null,
      listaGrupoFornecedores: [],
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredText: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    incluirLinhaGrupoFornecedor(idGrupo) {
      if (!idGrupo) return;
      let idsFornecedorLogado = [];
      if (this.usuarioLogado) {
        idsFornecedorLogado = this.usuarioLogado.idsGrupoFornecedor || [];
      }
      let pertenceAoGrupoDoUsuarioLogado = true;
      const jaExiste = this.listaGrupoFornecedores.some((g) => g.id === idGrupo);
      if (jaExiste) {
        this.$toast(this.$t('message.registro_ja_adicionado'));
        return;
      }

      const grupoEncontrado = this.gruposFornecedores.find((g) => g.id === idGrupo);
      pertenceAoGrupoDoUsuarioLogado = this.usuarioLogado.tipo === 'FUNCIONARIO' ? true : (idsFornecedorLogado.includes(grupoEncontrado.id));

      if (grupoEncontrado) {
        const grupoAdd = {
          ...grupoEncontrado,
          desabilitaDeletar: !pertenceAoGrupoDoUsuarioLogado,
          nomesCnpjsFormatados: grupoEncontrado.nomesCnpjs
            .map((item) => item.nome_cnpj)
            .join('\n'),
        };

        this.listaGrupoFornecedores.push(grupoAdd);

        this.filtroGrupoFornecedor = null;
      }
    },
    buscaGruposFornecedores(autocomplete) {
      this.$emit('BuscarGruposFornecedores', null, autocomplete);
    },
  },
};
</script>
<style scoped>

.row {
  margin-left: 0;
  margin-right: 0;
}

.hint-laranja .v-messages__message:not(.error--text) {
  color: orange !important;
}

.hint-laranja ::v-deep .v-messages__message:not(.error--text) {
  color: orange !important;
}

.custom-toggle {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.custom-toggle .v-btn {
  border-radius: 8px !important;
  border: none !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 36px !important;
  min-width: 80px !important;
  box-shadow: none !important;
}

.custom-toggle .v-btn:not(:last-child) {
  margin-right: 8px !important;
}

.lh-tight {
  line-height: 1.2;
  font-size: 0.85rem !important;
}

</style>
